/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * new_settings object
 * @export
 * @interface PutFleetsFleetIdNewSettings
 */
export interface PutFleetsFleetIdNewSettings {
    /**
     * Should free-move be enabled in the fleet
     * @type {boolean}
     * @memberof PutFleetsFleetIdNewSettings
     */
    isFreeMove?: boolean;
    /**
     * New fleet MOTD in CCP flavoured HTML
     * @type {string}
     * @memberof PutFleetsFleetIdNewSettings
     */
    motd?: string;
}

/**
 * Check if a given object implements the PutFleetsFleetIdNewSettings interface.
 */
export function instanceOfPutFleetsFleetIdNewSettings(value: object): value is PutFleetsFleetIdNewSettings {
    return true;
}

export function PutFleetsFleetIdNewSettingsFromJSON(json: any): PutFleetsFleetIdNewSettings {
    return PutFleetsFleetIdNewSettingsFromJSONTyped(json, false);
}

export function PutFleetsFleetIdNewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutFleetsFleetIdNewSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'isFreeMove': json['is_free_move'] == null ? undefined : json['is_free_move'],
        'motd': json['motd'] == null ? undefined : json['motd'],
    };
}

export function PutFleetsFleetIdNewSettingsToJSON(json: any): PutFleetsFleetIdNewSettings {
    return PutFleetsFleetIdNewSettingsToJSONTyped(json, false);
}

export function PutFleetsFleetIdNewSettingsToJSONTyped(value?: PutFleetsFleetIdNewSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_free_move': value['isFreeMove'],
        'motd': value['motd'],
    };
}

